import { render, staticRenderFns } from "./Svetofor.vue?vue&type=template&id=9aeeb6a6"
import script from "./Svetofor.vue?vue&type=script&lang=js"
export * from "./Svetofor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports